import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import M from 'materialize-css/dist/js/materialize';
import InventoryService from '../../../services/InventoryService';
import { translate, formatData, enumText } from '../../../utils/util';
import { Breadcrumbs, Button, Collapsible, ListPaginationNew } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import * as actionsInventory from '../../../actions/inventoryAction';
import { ENUMS, PERMISSIONS } from '../../../utils/constants';
import { checkPermission } from '../../../services/auth';
import SelectNew from '../../../components/UI/SelectNew';

const Log = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [, setInstanceM] = useState();
    const [inventoryDrop, setInventoryDrop] = useState([]);
    const [data, setData] = useState([]);
    const [filter, setFilter] = useState(
        {
            inventoryId: props.filter.inventoryId || "",
            success: false
        });

    useEffect(() => {
        if (props.logs?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData([...props.logs.items]);
            } else {
                setData((prevState) => ([...prevState, ...props.logs.items]));
            }
        }
        // eslint-disable-next-line
    }, [props?.logs?.items]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);

        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        props.getInventoryCodes(props.user.filter, (response) => {
            setInventoryDrop(response)
        });
        // eslint-disable-next-line
    }, []);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const search = () => {
        if (validateInputsRequired()) {
            props.getLogs(filter);
        }
    }

    const onSelectChange = (item) => {
        props.setLog(item);
        props.history.push({
            pathname: `../inventory/log/details`
        });
    }

    return (
        <div>
            <Breadcrumbs id="transmissionTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: 'Logs Envio SIM' }} />
            {
                checkPermission(PERMISSIONS.Inventory.ReenvioSIM) &&
                <div className="title" style={{ float: 'right', margin: '10px' }}>
                    <i className="material-icons" style={{ cursor: 'pointer' }} onClick={() => props.forceSendAllSIM()}>{'refresh'}</i>
                </div>
            }
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <Collapsible
                        id="filter"
                        header={translate("general:filter", "inventory")}
                        body={
                            <div className="row">
                                <div className='input-field no-padding col s12'>
                                    <SelectNew
                                        value={filter.inventoryId}
                                        required
                                        id="inventoryId"
                                        name="inventoryId"
                                        label={translate("inventoryCode", "inventory")}
                                        placeHolder={translate("chooseAnOption", "inventory")}
                                        data={inventoryDrop ? inventoryDrop.map((i) => { return { id: i.id, text: i.code }; }) : []}
                                        change={onChange}
                                    />
                                </div>
                            </div>
                        }
                    />
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text="Buscar" onClick={() => search()} />
                    </div>
                    <ListPaginationNew
                        page={props.logs?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={data.map((item) => (
                            <>
                                {
                                    checkPermission(PERMISSIONS.Inventory.ReenvioSIM) &&
                                    <span
                                        className="title sixth-text-color right"
                                        style={{ marginTop: '30px', marginRight: '20px' }}
                                        onClick={() => props.forceSendSIM(item.id, () => search())}
                                    >
                                        < i className='material-icons'>refresh</i>
                                    </span>
                                }
                                <div
                                    className="row"
                                    style={{ display: 'block', marginBottom: '0px', marginLeft: '0px' }}
                                    onClick={() => {
                                        onSelectChange(item);
                                    }}
                                >
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {translate('inventory:inventory')}: {item.inventory.inventoryCode}
                                    </span>
                                    <span className="title sixth-text-color" style={{ display: 'block' }} >
                                        {translate('inventory:lot')}: {item?.lot.lotNumber || ''}
                                    </span>
                                    {
                                        item?.lotItem != null &&
                                        <div className="title sixth-text-color" style={{ display: 'block' }} >
                                            {translate('inventory:inventoryNote')}: {item?.lotItem?.lotItemNumber || ''}
                                        </div>
                                    }
                                    <div className="col s12 second-text-color" style={{ display: 'block' }} >
                                        {translate('line-picking:transmission.operation')}: {translate(enumText(ENUMS.eLogInventoryOperation, item.operation), 'inventory') || ''}
                                    </div>

                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:transmission.erro-send')} - {formatData(item.createdOn)}
                                    </div>
                                    <div className="col s12 second-text-color"  >
                                        {translate('line-picking:linepicking.attempts')}: {item.attempts || ''}
                                    </div>
                                </div>
                            </>
                        ))}
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        inventoryList: state.inventoryReducer.inventoryList,
        logs: state.inventoryReducer.logs,
        filter: state.inventoryReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLogs: (filter, callback) => {
            dispatch(InventoryService.getLogs(filter, callback));
        },
        getInventoryCodes: (filter, callback) => {
            dispatch(InventoryService.getInventoryCodes(filter, callback));
        },
        setLog: (item) => {
            dispatch(actionsInventory.selectLog(item));
        },
        forceSendAllSIM: (callback) => {
            dispatch(InventoryService.forceSendAllSIM(callback));
        },
        forceSendSIM: (logId, callback) => {
            dispatch(InventoryService.forceSendSIM(logId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Log)));